export default {
	_get: function (string) {
		if (string) {
			var object = null;

			try {
				object = JSON.parse(string);
			}
			// eslint-disable-next-line no-empty
			catch (e) {}

			if (typeof object === 'object' || Array.isArray(object)) {
				return object;
			}

			return string;

		}

		return false;
	},
	_remove: function (key, session) {
		// Verify "removeItem" succeeded
		let verify = null;

		if (session === true) {
			verify = sessionStorage.getItem(key);
		} else {
			verify = localStorage.getItem(key);
		}

		if (verify !== null) {
			return false;
		}

		return true;

	},
	_set: function (key, session) {
		// Verify "setItem" succeeded
		let verify = null;

		if (session === true) {
			verify = sessionStorage.getItem(key);
		} else {
			verify = localStorage.getItem(key);
		}

		if (verify === null) {
			return false;
		}

		return true;
	},

	get: function (key) {
		var string = localStorage.getItem(key);
		return this._get(string);
	},
	remove: function (key) {
		localStorage.removeItem(key);

		return this._remove(key, false);
	},
	sessionGet: function (key) {
		let string = sessionStorage.getItem(key);

		return this._get(string);
	},
	sessionRemove: function (key) {
		sessionStorage.removeItem(key);

		return this._remove(key, true);
	},
	sessionSet: function (key, variable) {
		let string = typeof variable === 'object' ? JSON.stringify(variable) : variable;
		sessionStorage.setItem(key, string);

		return this._set(key, true);
	},
	set: function (key, variable) {
		let string = typeof variable === 'object' ? JSON.stringify(variable) : variable;
		localStorage.setItem(key, string);

		return this._set(key, false);
	}
};
